import {
  generalTitleIsRequired,
  instagramShouldHaveLessThan20Hashtags,
  isGeneralLinksHasTitles,
  isGeneralOptionsUrlsValid,
  lomavisPostApprovalExist,
  lomavisPostApprovalMultiStep,
  lomavisPostApprovalPublishWithSchedule,
  lomavisPostApprovalSaveAsApproved,
  lomavisPostApprovalSingleStep,
  mediaIsLoading,
  oneMediaShouldBeSelected,
  pinterestShouldHaveBoardSelected,
  pinterestShouldHaveValidLinks,
  postHasPublicationDate,
  PostHasTextOrMedia,
  TextLengthValid,
  validateDateIsInFuture,
  validateLinkedinDocumentTitleExists,
  validateYoutubeTitleExists,
  validateYoutubeTitleLength,
  locationShouldBeSelectedMultiPost,
  validateProductLinks
} from './buttonsValidatorsFunctions';
import {
  BTN_PLAN_AND_CONFIGURE,
  BTN_PLAN_PUBLICATION,
  BTN_PUBLISH_AND_CONFIGURE,
  BTN_PUBLISH_NOW,
  BTN_SAVE,
  BTN_SAVE_AS_DRAFT,
  BTN_SAVE_AS_COCKPIT_TEMPLATE,
  BTN_SAVE_FOR_APPROVAL,
  BTN_SAVE_FOR_APPROVAL_CLOUD,
  generalTitleIsRequiredKey,
  instagramShouldHaveLessThan20HashtagsKey,
  isGeneralLinksHasTitlesKey,
  isGeneralOptionsUrlsValidKey,
  isPostPublicationDateSet,
  isTextLengthValidKey,
  lomavisPostApprovalExistKey,
  lomavisPostApprovalMultiStepKey,
  lomavisPostApprovalSaveAsApprovedKey,
  lomavisPostApprovalSingleStepKey,
  lomavisPostApprovalWithScheduleKey,
  locationShouldBeSelectedMultiPostKey,
  mediaIsLoadingKey,
  oneMediaShouldBeSelectedKey,
  pinterestShouldHaveBoardSelectedKey,
  pinterestShouldHaveValidLinksKey,
  POST_STATUS_DRAFT,
  POST_STATUS_COCKPIT_TEMPLATE,
  POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
  POST_STATUS_READY,
  POST_STATUS_WAITING_FOR_APPROVAL,
  PostHasTextOrMediaKey,
  validateDateIsInFutureKey,
  validateLinkedinDocumentTitleExistsKey,
  validateYoutubeTitleExistsKey,
  youtubeTitleLengthKey,
  BTN_APPROVAL_REQUEST_APPROVE,
  validateProductLinksKey
} from './constants';
export const ALL_VALIDATORS = {
  [generalTitleIsRequiredKey]: {
    func: generalTitleIsRequired,
    title: `${generalTitleIsRequiredKey}_error_title`,
    message: `${generalTitleIsRequiredKey}_error_message`
  },
  [isGeneralLinksHasTitlesKey]: {
    func: isGeneralLinksHasTitles,
    title: `${isGeneralLinksHasTitlesKey}_error_title`,
    message: `${isGeneralLinksHasTitlesKey}_error_message`
  },
  [isGeneralOptionsUrlsValidKey]: {
    func: isGeneralOptionsUrlsValid,
    title: `${isGeneralOptionsUrlsValidKey}_error_title`,
    message: `${isGeneralOptionsUrlsValidKey}_error_message`
  },
  [oneMediaShouldBeSelectedKey]: {
    func: oneMediaShouldBeSelected,
    title: `${oneMediaShouldBeSelectedKey}_error_title`,
    message: `${oneMediaShouldBeSelectedKey}_error_message`
  },
  [youtubeTitleLengthKey]: {
    func: validateYoutubeTitleLength,
    title: `${youtubeTitleLengthKey}_error_title`,
    message: `${youtubeTitleLengthKey}_error_message`
  },
  [isTextLengthValidKey]: {
    func: TextLengthValid,
    title: `${isTextLengthValidKey}_error_title`,
    message: `${isTextLengthValidKey}_error_message`
  },
  [PostHasTextOrMediaKey]: {
    func: PostHasTextOrMedia,
    title: `${PostHasTextOrMediaKey}_error_title`,
    message: `${PostHasTextOrMediaKey}_error_message`
  },
  [isPostPublicationDateSet]: {
    func: postHasPublicationDate,
    title: `${isPostPublicationDateSet}_error_title`,
    message: `${isPostPublicationDateSet}_error_message`
  },
  [mediaIsLoadingKey]: {
    func: mediaIsLoading,
    title: `${mediaIsLoadingKey}_error_title`,
    message: `${mediaIsLoadingKey}_error_message`
  },
  [validateYoutubeTitleExistsKey]: {
    func: validateYoutubeTitleExists,
    title: `${validateYoutubeTitleExistsKey}_error_title`,
    message: `${validateYoutubeTitleExistsKey}_error_message`
  },
  [validateLinkedinDocumentTitleExistsKey]: {
    func: validateLinkedinDocumentTitleExists,
    title: `${validateLinkedinDocumentTitleExistsKey}_error_title`,
    message: `${validateLinkedinDocumentTitleExistsKey}_error_message`
  },
  [validateDateIsInFutureKey]: {
    func: validateDateIsInFuture,
    title: `${validateDateIsInFutureKey}_error_title`,
    message: `${validateDateIsInFutureKey}_error_message`
  },
  [instagramShouldHaveLessThan20HashtagsKey]: {
    func: instagramShouldHaveLessThan20Hashtags,
    title: `${instagramShouldHaveLessThan20HashtagsKey}_error_title`,
    message: `${instagramShouldHaveLessThan20HashtagsKey}_error_message`
  },
  [pinterestShouldHaveBoardSelectedKey]: {
    func: pinterestShouldHaveBoardSelected,
    title: `${pinterestShouldHaveBoardSelectedKey}_error_title`,
    message: `${pinterestShouldHaveBoardSelectedKey}_error_message`
  },
  [pinterestShouldHaveValidLinksKey]: {
    func: pinterestShouldHaveValidLinks,
    title: `${pinterestShouldHaveValidLinksKey}_error_title`,
    message: `${pinterestShouldHaveValidLinksKey}_error_message`
  },
  [locationShouldBeSelectedMultiPostKey]: {
    func: locationShouldBeSelectedMultiPost,
    title: `${locationShouldBeSelectedMultiPostKey}_error_title`,
    message: `${locationShouldBeSelectedMultiPostKey}_error_message`
  },

  [lomavisPostApprovalExistKey]: {
    func: lomavisPostApprovalExist,
    title: `${lomavisPostApprovalExistKey}_error_title`,
    message: `${lomavisPostApprovalExistKey}_error_message`
  },
  [lomavisPostApprovalSingleStepKey]: {
    func: lomavisPostApprovalSingleStep,
    title: `${lomavisPostApprovalSingleStepKey}_error_title`,
    message: `${lomavisPostApprovalSingleStepKey}_error_message`
  },
  [lomavisPostApprovalMultiStepKey]: {
    func: lomavisPostApprovalMultiStep,
    title: `${lomavisPostApprovalSingleStepKey}_error_title`,
    message: `${lomavisPostApprovalSingleStepKey}_error_message`
  },
  [lomavisPostApprovalWithScheduleKey]: {
    func: lomavisPostApprovalPublishWithSchedule,
    title: `${lomavisPostApprovalWithScheduleKey}_error_title`,
    message: `${lomavisPostApprovalWithScheduleKey}_error_message`
  },
  [lomavisPostApprovalSaveAsApprovedKey]: {
    func: lomavisPostApprovalSaveAsApproved,
    title: `${lomavisPostApprovalSaveAsApprovedKey}_error_title`,
    message: `${lomavisPostApprovalSaveAsApprovedKey}_error_message`
  },
  [validateProductLinksKey]: {
    func: validateProductLinks,
    title: `${validateProductLinksKey}_error_title`,
    message: `${validateProductLinksKey}_error_message`
  }
};

const SAVE_AS_DRAFT_VALIDATORS = [
  isTextLengthValidKey,
  PostHasTextOrMediaKey,
  mediaIsLoadingKey,
  youtubeTitleLengthKey,
  isGeneralOptionsUrlsValidKey,
  isGeneralLinksHasTitlesKey,
  generalTitleIsRequiredKey,
  pinterestShouldHaveValidLinksKey,
  validateProductLinksKey
];

export const BUTTONS_VALIDATORS = {
  [BTN_SAVE_FOR_APPROVAL_CLOUD]: {
    isTextLengthValidKey,
    PostHasTextOrMediaKey,
    mediaIsLoadingKey,
    youtubeTitleLengthKey,
    oneMediaShouldBeSelectedKey,
    isGeneralOptionsUrlsValidKey,
    isGeneralLinksHasTitlesKey,
    generalTitleIsRequiredKey,
    validateLinkedinDocumentTitleExistsKey,
    instagramShouldHaveLessThan20HashtagsKey,
    pinterestShouldHaveBoardSelectedKey,
    pinterestShouldHaveValidLinksKey,
    lomavisPostApprovalSingleStepKey,
    lomavisPostApprovalMultiStepKey,
    validateProductLinksKey
  },
  [BTN_SAVE_AS_DRAFT]: {
    validators: SAVE_AS_DRAFT_VALIDATORS
  },
  [BTN_SAVE_AS_COCKPIT_TEMPLATE]: {
    validators: SAVE_AS_DRAFT_VALIDATORS
  },
  [BTN_PLAN_PUBLICATION]: {
    validators: [
      isTextLengthValidKey,
      isPostPublicationDateSet,
      validateDateIsInFutureKey,
      PostHasTextOrMediaKey,
      mediaIsLoadingKey,
      oneMediaShouldBeSelectedKey,
      isGeneralOptionsUrlsValidKey,
      isGeneralLinksHasTitlesKey,
      generalTitleIsRequiredKey,
      validateYoutubeTitleExistsKey,
      validateLinkedinDocumentTitleExistsKey,
      instagramShouldHaveLessThan20HashtagsKey,
      pinterestShouldHaveBoardSelectedKey,
      pinterestShouldHaveValidLinksKey,
      locationShouldBeSelectedMultiPostKey
    ]
  },
  [BTN_PUBLISH_NOW]: {
    validators: [
      isTextLengthValidKey,
      PostHasTextOrMediaKey,
      mediaIsLoadingKey,
      youtubeTitleLengthKey,
      oneMediaShouldBeSelectedKey,
      isGeneralOptionsUrlsValidKey,
      isGeneralLinksHasTitlesKey,
      generalTitleIsRequiredKey,
      validateYoutubeTitleExistsKey,
      validateLinkedinDocumentTitleExistsKey,
      instagramShouldHaveLessThan20HashtagsKey,
      pinterestShouldHaveBoardSelectedKey,
      pinterestShouldHaveValidLinksKey,
      locationShouldBeSelectedMultiPostKey,
      validateProductLinksKey
    ]
  },
  [BTN_SAVE_FOR_APPROVAL]: {
    validators: [
      isTextLengthValidKey,
      PostHasTextOrMediaKey,
      mediaIsLoadingKey,
      youtubeTitleLengthKey,
      oneMediaShouldBeSelectedKey,
      isGeneralOptionsUrlsValidKey,
      isGeneralLinksHasTitlesKey,
      generalTitleIsRequiredKey,
      validateLinkedinDocumentTitleExistsKey,
      instagramShouldHaveLessThan20HashtagsKey,
      pinterestShouldHaveBoardSelectedKey,
      pinterestShouldHaveValidLinksKey,
      lomavisPostApprovalExistKey,
      lomavisPostApprovalSingleStepKey,
      lomavisPostApprovalMultiStepKey,
      lomavisPostApprovalWithScheduleKey,
      lomavisPostApprovalSaveAsApprovedKey,
      locationShouldBeSelectedMultiPostKey
    ]
  },
  [BTN_PUBLISH_AND_CONFIGURE]: {
    validators: [
      isTextLengthValidKey,
      PostHasTextOrMediaKey,
      mediaIsLoadingKey,
      youtubeTitleLengthKey,
      oneMediaShouldBeSelectedKey,
      isGeneralOptionsUrlsValidKey,
      isGeneralLinksHasTitlesKey,
      generalTitleIsRequiredKey,
      instagramShouldHaveLessThan20HashtagsKey,
      pinterestShouldHaveBoardSelectedKey,
      pinterestShouldHaveValidLinksKey,
      locationShouldBeSelectedMultiPostKey,
      validateProductLinksKey
    ]
  },
  [BTN_PLAN_AND_CONFIGURE]: {
    validators: [
      isTextLengthValidKey,
      PostHasTextOrMediaKey,
      isPostPublicationDateSet,
      validateDateIsInFutureKey,
      mediaIsLoadingKey,
      youtubeTitleLengthKey,
      oneMediaShouldBeSelectedKey,
      isGeneralOptionsUrlsValidKey,
      isGeneralLinksHasTitlesKey,
      generalTitleIsRequiredKey,
      instagramShouldHaveLessThan20HashtagsKey,
      pinterestShouldHaveBoardSelectedKey,
      pinterestShouldHaveValidLinksKey,
      locationShouldBeSelectedMultiPostKey,
      validateProductLinksKey
    ]
  }
};

export const BUTTONS_CONFIG = [
  {
    key: BTN_SAVE,
    showOnCloud: true,
    showOnPostStatus: [
      POST_STATUS_DRAFT,
      POST_STATUS_WAITING_FOR_APPROVAL,
      POST_STATUS_READY,
      POST_STATUS_COCKPIT_TEMPLATE
    ],
    showOnMultipost: true,
    showOnCockpit: true,
    showOnPlanningOnly: false,
    showInPublishedPost: true,
    buttonTextCloud: 'save',
    buttonTextNormal: 'save'
  },
  {
    key: BTN_SAVE_AS_DRAFT,
    showOnCloud: true,
    showOnMultipost: true,
    showOnPostStatus: [
      POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
      POST_STATUS_WAITING_FOR_APPROVAL,
      POST_STATUS_READY,
      null
    ],
    showOnCockpit: true,
    showOnPlanningOnly: false,
    buttonTextCloud: 'save_as_draft',
    buttonTextNormal: 'save_as_draft',
    default: true
  },
  {
    key: BTN_SAVE_AS_COCKPIT_TEMPLATE,
    showOnCloud: false,
    showOnMultipost: true,
    showOnPostStatus: [null],
    showOnCockpit: true,
    showOnPlanningOnly: false,
    buttonTextCloud: 'save_as_template',
    buttonTextNormal: 'save_as_template'
  },
  {
    key: BTN_PUBLISH_NOW,
    showOnCloud: true,
    showOnPostStatus: [
      POST_STATUS_DRAFT,
      POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
      POST_STATUS_WAITING_FOR_APPROVAL,
      POST_STATUS_READY,
      null
    ],
    showOnMultipost: true,
    showOnCockpit: true,
    showOnPlanningOnly: false,
    showInPublishedPost: true,
    buttonTextCloud: 'make_available',
    buttonTextNormal: 'publish_now'
  },
  {
    key: BTN_PLAN_PUBLICATION,
    showOnCloud: false,
    showOnMultipost: true,
    showOnPostStatus: [
      POST_STATUS_DRAFT,
      POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
      POST_STATUS_WAITING_FOR_APPROVAL,
      null
    ],
    showOnCockpit: true,
    showOnPlanningOnly: false,

    buttonTextCloud: 'plan_now',
    buttonTextNormal: 'plan_now'
  },
  {
    key: BTN_PUBLISH_AND_CONFIGURE,
    showOnCloud: true,
    showOnMultipost: false,
    showOnPostStatus: [
      POST_STATUS_DRAFT,
      POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
      POST_STATUS_WAITING_FOR_APPROVAL,
      null
    ],
    showOnCockpit: true,
    showOnPlanningOnly: false,
    buttonTextCloud: 'make_available_and_notify',
    buttonTextNormal: 'publish_and_configure'
  },
  {
    key: BTN_PLAN_AND_CONFIGURE,
    showOnCloud: true,
    showOnMultipost: false,
    showOnPostStatus: [
      POST_STATUS_DRAFT,
      POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
      POST_STATUS_WAITING_FOR_APPROVAL,
      null
    ],
    showOnCockpit: true,
    showOnPlanningOnly: true,
    buttonTextCloud: 'make_available_and_configure',
    buttonTextNormal: 'plan_and_configure'
  },
  {
    key: BTN_SAVE_FOR_APPROVAL,
    showOnCloud: false,
    showOnMultipost: true,
    showOnPostStatus: [
      POST_STATUS_DRAFT,
      POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
      null
    ],
    showOnCockpit: true,
    showOnPlanningOnly: false,
    buttonTextCloud: 'save_for_approval',
    buttonTextNormal: 'save_for_approval'
  },
  {
    key: BTN_SAVE_FOR_APPROVAL_CLOUD,
    showOnCloud: true,
    showOnMultipost: false,
    showOnPostStatus: [
      POST_STATUS_DRAFT,
      POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
      null
    ],
    showOnCockpit: false,
    showOnPlanningOnly: false,
    buttonTextCloud: 'save_for_approval',
    buttonTextNormal: 'save_for_approval'
  }
];
